import axios from 'axios'
import qs from 'qs'

axios.defaults.timeout = 10000;                        //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';        //配置请求头
axios.defaults.baseURL = 'https://chejianadmin.dayujh.cn';   //配置接口地址

var storage = window.localStorage

//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
    //在发送请求之前做某件事
    let account = localStorage.account
    if(config.data) {
      config.data.sfAccount = account
    }else{
      config.data = {
        sfAccount: account
      }
    }
    if(config.method  === 'post'){
        config.data = qs.stringify(config.data);
    }
    // storage.token && (config.headers.Authorization = storage.token); 
    return config;
},(error) =>{
    console.log('错误的传参')
    return Promise.reject(error);
});

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) =>{
    //对响应数据做些事
    // console.log(res)
    
    if(!res.data.success){
      if(res.data.status==500){
        storage.clear()
        window.location.replace(window.location.host); 
      }
      return Promise.resolve(res);
    }
    
    
    return res;
}, (error) => {
    console.log('网络异常')
    return Promise.reject(error);
});

//返回一个Promise(发送post请求)
export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(response => {
                resolve(response);
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error)
            })
    })
}
////返回一个Promise(发送get请求)
export function get(url, param) {
    return new Promise((resolve, reject) => {
        axios.get(url, {params: param})
            .then(response => {
                resolve(response)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
export default {
    post,
    get,
}
